import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_CASES',
    icon: 'ServerIcon',
    action: constants.action.permissionDebtCaseView,
    resource: constants.resource.debtCase,
    children: [
      {
        title: 'DEBTIA_CASE_LIST',
        route: 'cases',
        action: constants.action.permissionDebtCaseView,
        resource: constants.resource.debtCase,
      },
      {
        title: 'DEBTIA_CASE_GROUPS',
        route: 'case-groups',
        action: constants.action.permissionListCaseGroup,
        resource: constants.resource.caseGroups,
      },
    ],
  },
]
